import React, { createContext, useState, useContext, useEffect } from 'react';
import { verifyToken as verifyTokenAPI } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [organisations, setOrganisations] = useState([]);
  const [selectedOrganisation, setSelectedOrganisation] = useState(null);

  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const response = await verifyTokenAPI();
          if (response.valid) {
            setUser(response.user);
            if (response.user.allOrganisations) {
              setOrganisations(response.user.allOrganisations);
            }
            if (response.user.organisation) {
              setSelectedOrganisation(response.user.organisation);
            }
          } else {
            localStorage.removeItem('token');
          }
        } catch (error) {
          console.error('Auth verification failed:', error);
          localStorage.removeItem('token');
        }
      }
      setLoading(false);
    };

    initAuth();
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('token', token);
    setUser(userData);
    if (userData.allOrganisations) {
      setOrganisations(userData.allOrganisations);
    }
    if (userData.organisation) {
      setSelectedOrganisation(userData.organisation);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setOrganisations([]);
    setSelectedOrganisation(null);
  };

  const switchOrganisation = (organisation) => {
    setSelectedOrganisation(organisation);
  };

  const value = {
    user,
    loading,
    login,
    logout,
    organisations,
    selectedOrganisation,
    setSelectedOrganisation: switchOrganisation,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};